import { Link } from 'react-router-dom'
import { Logo } from './Logo'
import { ButtonLink } from '@/components/ui/Button'
import { FOOTER_NAV, PARTNER_CONTACT_PATH } from '@/lib/site'

/**
 * The footer is a band like every other: same rounded rail and margins, with
 * the deep indigo→periwinkle wash the design closes each page on.
 */
export function Footer() {
  return (
    <footer className="relative mx-auto w-full max-w-[1860px] overflow-hidden rounded-band bg-[linear-gradient(105deg,#232c5c_0%,#3b4694_45%,#6a70e0_100%)] text-white shadow-band">
      <div className="shell grid gap-12 py-16 sm:grid-cols-2 lg:grid-cols-4">
        <div className="min-w-0">
          <Logo tone="dark" />
          <p className="mt-4 max-w-[34ch] text-[12.5px] leading-[1.7] text-white/70">
            Raw business data, arranged. What is recorded in your own documents, and what is
            projected as a range.
          </p>
          <p className="mt-4 font-mono text-[10.5px] tracking-[0.08em] text-white/55">
            PHASE 0 · NOT PUBLICLY AVAILABLE
          </p>
        </div>

        {FOOTER_NAV.map((group) => (
          <nav key={group.heading} aria-label={group.heading} className="min-w-0">
            <h2 className="mb-3 font-mono text-[10.5px] uppercase tracking-[0.14em] text-white/55">
              {group.heading}
            </h2>
            <ul className="grid gap-2.5">
              {group.items.map((route) => (
                <li key={route.key}>
                  <Link
                    to={route.path}
                    className="inline-flex min-h-[28px] items-center rounded text-[13px] font-medium text-white/80 underline-offset-4 transition-colors hover:text-white hover:underline"
                  >
                    {route.footerLabel}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        ))}

        <div className="min-w-0">
          <h2 className="mb-3 font-mono text-[10.5px] uppercase tracking-[0.14em] text-white/55">
            Status
          </h2>
          <p className="mb-4 text-[12.5px] leading-[1.7] text-white/75">
            The dashboard, setup wizard, projections, the Ask bar and connectors are not built yet.
            Projection, temporal, ensemble and Ask flags default off.
          </p>
          <ButtonLink
            to={PARTNER_CONTACT_PATH}
            className="border-white/25 bg-white/15 text-white shadow-none backdrop-blur hover:border-white/40 hover:bg-white/25"
          >
            Become a design partner
          </ButtonLink>
        </div>
      </div>

      <div className="shell flex flex-wrap justify-between gap-4 border-t border-white/15 py-5 pb-10">
        <p className="text-[11.5px] text-white/65">© 2026 GodEngine. Operated by FORGE X, India.</p>
        <p className="font-mono text-[11px] text-white/65">
          No figure on this site is a customer figure.
        </p>
      </div>
    </footer>
  )
}
